import { useAppSelector } from '@/hooks/useAppSelector';
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import React, { useState } from 'react';
import { RectificativaParcialForm } from './RectificativaParcialForm';
import { RectificativaTotalForm } from './RectificativaTotalForm';

interface Props {
  type: 'parcial' | 'total';
  disabled?: boolean;
}
export const RectificativaButton = ({ type, disabled }: Props) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const buttonLabel = type === 'parcial' ? `Generar rectificativa ${type}` : 'Rectificar a 0';
  const dialogTitle = type === 'parcial' ? `Generar factura rectificativa ${type}` : 'Generar rectificación a 0';

  return (
    <>
      <Button
        style={{
          marginRight: '20px',
          backgroundColor: !disabled ? '#F39868' : '#d3d3d3d3',
          color: '#fff',
          borderRadius: 7,
        }}
        onClick={() => setOpenDialog(true)}
        disabled={disabled}>
        <Typography style={{ fontWeight: 'bold' }}>{buttonLabel} </Typography>
      </Button>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth={'xl'}>
        <Typography style={{ padding: '1rem' }} variant="h4">
          {dialogTitle}
        </Typography>
        <DialogContent>
          <Box minWidth={500}>
            {type === 'parcial' && <RectificativaParcialForm toggleDialogClose={() => setOpenDialog(false)} />}
            {type === 'total' && <RectificativaTotalForm toggleDialogClose={() => setOpenDialog(false)} />}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};
